import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueRouter from 'vue-router'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  options: {
    customProperties: true,
  },
})
Vue.use(VueRouter)
/* Palette generated by Material Palette - materialpalette.com/deepPurple/deepPurple */
export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.deepPurple.lighten4,
        accent: colors.deepPurple.accent2,
        default: colors.deepPurple.base,
        text: colors.white,
        textPrimary: colors.grey.darken4,
        textSecondary: colors.grey.darken1,
      },
      dark: {
        primary: colors.deepPurple.darken2,
        accent: colors.deepPurple.accent2,
        default: colors.deepPurple.lighten1,
        text: colors.white,
        textPrimary: colors.grey.lighten3,
        textSecondary: colors.grey.lighten1,
      },
    },
  },
})
